export const is_iphone = () => (window.innerWidth >= 100 && window.innerWidth
  <= 798);
